// Explicit allowlist of who can see the Asignación de Cursos configuration (period, responses and
// results pages), per organization: organizationId -> emails. Requested by a single school that
// doesn't want every ECE/COUNSELOR to have access - so an organization that isn't listed here keeps
// today's behavior (every ECE can see it).
//
// Frontend-only: this hides the nav link and blocks the routes, but the API itself still accepts
// any COUNSELOR of the organization.
//
// Example:
//   123: ['persona1@colegio.cl', 'persona2@colegio.cl']
export const COURSE_ASSIGNMENT_MANAGERS = {
  // SSCC Manquehue
  35: [
    'pamela.cabello@ssccmanquehue.cl',
    'gabriela.cortes@ssccmanquehue.cl',
    'denise.gobrin@ssccmanquehue.cl',
    'margarita.puga@ssccmanquehue.cl',
    'magdalena.poblete@ssccmanquehue.cl',
    'loreto.carvacho@ssccmanquehue.cl',
    'paulina.vergara@ssccmanquehue.cl',
    'pilar.rabanales@ssccmanquehue.cl',
    'ignacio.bustos@ssccmanquehue.cl',
    'andrea.valenzuela@ssccmanquehue.cl',
    'soporte+ece@braveup.cl',
    'luciano+test2@braveup.com'
  ]
}
